import {
  IconButton,
  InputAdornment,
  TextField,
  TextFieldProps,
  useMediaQuery,
} from '@mui/material'
import React, { FC, useState } from 'react'
import { useController, UseControllerProps } from 'react-hook-form'
import cn from '@/utils/cn'
import { Visibility, VisibilityOff } from '@mui/icons-material'

const s = cn('input-organization')

type IInput = {
  allowDecimal?: boolean
}

type InputProps = TextFieldProps & IInput & UseControllerProps<any>

const Input: FC<InputProps> = ({ name, control, allowDecimal, ...props }) => {
  const [showPassword, setShowPassword] = useState(false)

  const is4K = useMediaQuery('(min-width:2560px)')

  const {
    field,
    fieldState: { invalid, isTouched, isDirty },
    formState: { touchedFields, dirtyFields, errors },
  } = useController({
    name,
    control,
  })

  const handleClickShowPassword = () => setShowPassword((show) => !show)

  const handleMouseDownPassword = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.preventDefault()
  }
  // @ts-ignore
  return (
    // @ts-ignore
    <TextField
      // @ts-ignore
      value={field.value ?? ''}
      color='primary'
      className={s()}
      style={{ display: props.type === 'hidden' ? 'none' : '' }}
      autoComplete='new-password'
      variant='filled'
      sx={{}}
      size={is4K ? undefined : 'small'}
      margin='none'
      fullWidth
      type={
        props.type === 'password'
          ? showPassword
            ? 'text'
            : 'password'
          : 'text'
      }
      error={!!errors[name]}
      helperText={errors[name]?.message as string}
      // @ts-ignore
      onChange={(e) => {
        if (props.type === 'number') {
          if (allowDecimal) {
            // Allow digits, comma, and dot
            let value = e.target.value.replace(/[^0-9.,]/g, '')
            // Replace comma with dot
            value = value.replace(',', '.')
            // Allow only one decimal separator
            const parts = value.split('.')
            if (parts.length > 2) {
              value = parts[0] + '.' + parts.slice(1).join('')
            }
            // Limit to 3 decimal places
            if (parts.length === 2 && parts[1].length > 3) {
              value = parts[0] + '.' + parts[1].substring(0, 3)
            }
            field.onChange(value)
          } else {
            field.onChange(e.target.value.replace(/[^0-9]/g, ''))
          }
        } else {
          field.onChange(e.target.value)
        }
      }}
      InputProps={{
        endAdornment:
          props.type === 'password' ? (
            <InputAdornment position='end'>
              <IconButton
                aria-label='toggle password visibility'
                onClick={handleClickShowPassword}
                onMouseDown={handleMouseDownPassword}
                edge='end'
              >
                {showPassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>
          ) : null,
        disableUnderline: true,
      }}
      {...field}
      {...props}
    />
  )
}

export default Input
